import { render, staticRenderFns } from "./shot-item.vue?vue&type=template&id=52faf692&scoped=true"
import script from "./shot-item.vue?vue&type=script&lang=js"
export * from "./shot-item.vue?vue&type=script&lang=js"
import style0 from "./shot-item.vue?vue&type=style&index=0&id=52faf692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52faf692",
  null
  
)

export default component.exports